import { Outlet } from 'react-router-dom'

import backgroundImage from '@assets/images/background-pattern.svg'
import Header from '@components/Header'
import LegalFooter from '@components/LegalFooter'
import SideNavBar from '@components/SideNavBar'
import RootLayout from '@components/layouts/RootLayout'

import { StyledCommonLayout, StyledCommonLayoutMainContent, StyledCommonLayoutMainWrapper } from './index.styles'

const CommonLayout = ({ fixedViewport = false }: { fixedViewport?: boolean }) => {
  return (
    <RootLayout>
      <StyledCommonLayout $backgroundImage={backgroundImage} $fixedViewport={fixedViewport} data-testid="common-layout">
        <Header />
        <StyledCommonLayoutMainWrapper $fixedViewport={fixedViewport} data-testid="common-layout-main">
          <SideNavBar />
          <StyledCommonLayoutMainContent data-testid="common-layout-main-content">
            <Outlet />
          </StyledCommonLayoutMainContent>
        </StyledCommonLayoutMainWrapper>
        <LegalFooter withAdditionalPadding />
      </StyledCommonLayout>
    </RootLayout>
  )
}

export default CommonLayout
